import { GridColDef } from '@mui/x-data-grid-pro';
import GpanelContactsTrashPage from '../gpanel-contacts-trash-page';
import { Label } from '../../../shared/types';
import {
  useOrganizationDirectoryContactsQuery,
  useTrashLabelsQuery,
} from '../../../gpanel-contacts-queries';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import { useGpanelContactsPermissions } from '../../../shared/hooks/use-gpanel-contacts-permissions';
import { GPanelContactsPermissions } from '../../../../../../utils/roles/client-roles';
import { useMemo, useState } from 'react';
import GpanelContactsRecoverLabelsDialog from './gpanel-contacts-recover-labels-dialog';
import GpanelContactsEmptyLabelsTrashDialog from './gpanel-contacts-empty-labels-trash-dialog';
import { getDateTimeString } from '../../../shared/utils';
import { useUserSettings } from '../../../../../../utils/use-user-settings';

dayjs.extend(relativeTime);

export default function GpanelContactsTrashLabels() {
  const { PERMISSIONS } = useGpanelContactsPermissions();
  const query = useTrashLabelsQuery();
  const [selectedLabelIds, setSelectedLabelIds] = useState<number[] | null>(
    null
  );
  const [isEmptyModalOpened, setEmptyModalOpened] = useState<boolean>(false);
  const { viewType } = useUserSettings();

  const { data: contacts = [] } = useOrganizationDirectoryContactsQuery();

  const contactCountsByLabelId = useMemo(() => {
    const counts = new Map<number, number>();
    if (!contacts) {
      return counts;
    }
    for (const contact of contacts) {
      if (contact.labelIds) {
        for (const labelId of contact.labelIds) {
          counts.set(labelId, (counts.get(labelId) || 0) + 1);
        }
      }
    }
    return counts;
  }, [contacts]);

  const columns: GridColDef<Label>[] = [
    {
      field: 'labelName',
      headerName: 'Label Name',
      flex: 1,
      valueGetter: (_value, row) => {
        return row.name;
      },
    },
    {
      field: 'numberOfContacts',
      headerName: 'Number of contacts in label',
      flex: 1,
      valueGetter: (_value, row) => {
        return contactCountsByLabelId.get(row.id) ?? 0;
      },
    },
    {
      field: 'dateDeleted',
      headerName: 'Date Trashed',
      flex: 1,
      valueGetter: (_value, row) => {
        return getDateTimeString(row.trashedTime);
      },
    },
  ];

  return (
    <>
      <GpanelContactsTrashPage
        title="Labels"
        gridKey={viewType.trashedContactLabelsGridStates?.activeGridState}
        query={query}
        columns={columns}
        recoverPermission={{
          value: PERMISSIONS.recoverTrashedLabels,
          name: GPanelContactsPermissions.RecoverTrashedLabels.name,
        }}
        emptyPermission={{
          value: PERMISSIONS.emptyTrashedLabels,
          name: GPanelContactsPermissions.EmptyTrashedLabels.name,
        }}
        onRecover={(model) => {
          setSelectedLabelIds(model as number[]);
        }}
        onEmpty={() => {
          setEmptyModalOpened(true);
        }}
      />
      {selectedLabelIds && (
        <GpanelContactsRecoverLabelsDialog
          handleClose={() => setSelectedLabelIds(null)}
          labelIds={selectedLabelIds}
        />
      )}
      {isEmptyModalOpened && (
        <GpanelContactsEmptyLabelsTrashDialog
          handleClose={() => setEmptyModalOpened(false)}
        />
      )}
    </>
  );
}
